import * as faker from 'faker';
import {
  AssignmentApiModel,
  AssignmentLoadPriorityEnum,
  AssignmentStatusEnum,
} from 'app/models/assignment-api.model';
import { MwPayloadModel } from 'app/models/payload.model';
// Generators for testing or data mocking
export const generateAssignment = (): AssignmentApiModel => {
  return {
    number: faker.random.number().toString(),
    orderLineNumber: '',
    orderNumber: '',
    requestedVehicleTypeName: '',
    vehiclePlateNumber: '',
    driverName: '',
    customerProjectId: faker.random.number(),
    customerProjectName: '',
    customerProjectNumber: '',
    projectId: faker.random.number(),
    projectName: '',
    projectNumber: '',
    productTypeName: '',
    productGroupName: '',
    deliveriesCount: faker.random.number(),
    assignmentId: faker.random.number(),
    assignmentKey: faker.random.number().toString(),
    orderId: faker.random.number(),
    orderLineId: faker.random.number(),
    productTypeId: faker.random.number(),
    driverId: faker.random.number(),
    vehicleId: faker.random.number(),
    requestedVehicleTypeId: faker.random.number(),
    startDate: new Date(),
    endDate: new Date(),
    comment: '',
    contactTransportId: faker.random.number(),
    contactTransportFullName:
      faker.name.firstName() + ' ' + faker.name.lastName(),
    contactTransportPhone: '',
    customerId: faker.random.number(),
    status:
      AssignmentStatusEnum[
        faker.random.arrayElement(
          Object.getOwnPropertyNames(AssignmentStatusEnum)
        )
      ],
    orderIndex: faker.random.number(),
    loadingDateTime: new Date(),
    loadingTimePriority:
      AssignmentLoadPriorityEnum[
        faker.random.arrayElement(
          Object.getOwnPropertyNames(AssignmentLoadPriorityEnum)
        )
      ],
    loadingSiteId: faker.random.number(),
    loadingSiteName: '',
    loadingAddress: '',
    loadingAddressGeoLocation: null,
    loadingComment: '',
    loadingCustomerProjectId: faker.random.number(),
    unloadingDateTime: new Date(),
    unloadingTimePriority:
      AssignmentLoadPriorityEnum[
        faker.random.arrayElement(
          Object.getOwnPropertyNames(AssignmentLoadPriorityEnum)
        )
      ],
    unloadingSiteId: faker.random.number(),
    unloadingSiteName: '',
    unloadingAddress: '',
    unloadingAddressGeoLocation: null,
    unloadingComment: '',
    unloadingCustomerProjectId: faker.random.number(),
    isConfirmedByDriver: faker.random.boolean(),
    isActive: faker.random.boolean(),
    quantity: faker.random.number(),
    unitName: faker.commerce.color(),
    unitId: faker.random.number(),
    customerKey: faker.random.number().toString(),
    customerName: faker.company.companyName(),
    isRequestedVehicleWithTrailer: faker.random.boolean(),
    priority: null,
    loadAddressId: null,
    unloadAddressId: null,
    isReturnDelivery: faker.random.boolean(),
  };
};

export const generateAssignments = (
  count = faker.random.number({ min: 1, max: 20 })
): AssignmentApiModel[] => {
  return Array.apply(null, Array(count)).map(() => generateAssignment());
};

export const generateAssignmentsResponse = (): MwPayloadModel<
  AssignmentApiModel[]
> => {
  const results = generateAssignments();
  return { results, count: results.length };
};
